// Map locales to Whitelabels
var whitelabels = {
    "de-DE": "DE_billiger-mietwagen",
    "fr-FR": "FR_carigami",
    "es-ES": "ES_floyt",
    "it-IT": "IT_floyt",
    "nl-NL": "NL_floyt"
};
var getWhitelabel = function() {
    var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "de-DE";
    return whitelabels[locale];
};
var DEFAULT_TIMEOUT = 4000;
export { DEFAULT_TIMEOUT, getWhitelabel };
